<template>
  <div style="padding: 30px 20px">
    <el-row class="display-flex">
      <div class="text-right formLabel">节点ID：</div>
      <div style="flex: 1">
        <el-input v-model="form.id" disabled size="mini"></el-input>
      </div>
    </el-row>
    <el-row class="display-flex margin-top-15">
      <div class="text-right formLabel">节点类型：</div>
      <div style="flex: 1">
        <el-input v-model="form.$type" disabled size="mini"></el-input>
      </div>
    </el-row>
    <el-row class="display-flex margin-top-15">
      <div class="text-right formLabel">节点名称：</div>
      <div style="flex: 1">
        <el-input v-model="form.name" size="mini"
                  :disabled="!select"
                  @input="nameChange"></el-input>
      </div>
    </el-row>
    <el-row class="display-flex margin-top-15" v-if="taskListener">
      <div class="text-right formLabel">任务监听：</div>
      <div style="flex: 1">
        <el-select v-model="form.taskListener"
                   style="width: 100%"
                   :disabled="!select"
                   @change="addDynamicProperties"
                   size="mini">
          <el-option v-for="item in taskListenerService"
                     :key="item.id" :label="item.name"
                     :value="item.val1">
          </el-option>
        </el-select>
      </div>
    </el-row>
    <div v-if="Object.keys(dynamicObj).length && taskListener">
      <div v-for="(item,index) in Object.keys(dynamicObj)" :key="index">
        <div v-if="item === 'pointId'">
          <el-row class="display-flex margin-top-15">
            <div class="text-right formLabel">空间：</div>
            <div style="flex: 1">
              <el-cascader
                :disabled="!select"
                :props="defaultProps"
                :options="spaceTree"
                change-on-select="true"
                placeholder="请选择空间"
                size="mini"
                style="width: 100%"
                @change="getDeviceList(false)"
                v-model="form.spaceIds">
              </el-cascader>
            </div>
          </el-row>
          <el-row class="display-flex margin-top-15">
            <div class="text-right formLabel">设备：</div>
            <div style="flex: 1">
              <el-select
                :disabled="!select"
                @change="getPointListByDeviceId(false)"
                placeholder="请选择设备"
                size="mini"
                style="width: 100%;"
                v-model="form.deviceId">
                <el-option
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  v-for="item in deviceList">
                </el-option>
              </el-select>
            </div>
          </el-row>
          <el-row class="display-flex margin-top-15">
            <div class="text-right formLabel">测点：</div>
            <div style="flex: 1">
              <el-select
                :disabled="!select"
                placeholder="请选择测点"
                size="mini"
                style="width: 100%;"
                @change="selectPoint"
                v-model="form.pointId">
                <el-option
                  :key="item.id"
                  :label="item.name +'_'+ item.code"
                  :value="item.id"
                  v-for="item in pointList">
                </el-option>
              </el-select>
            </div>
          </el-row>
        </div>
        <el-row class="display-flex margin-top-15" v-else>
          <div class="text-right formLabel">{{ dynamicObj[item] }}：</div>
          <div style="flex: 1">
            <el-input v-model="form[item]" size="mini"
                      :disabled="!select"
                      @input="updateModelingProperties"></el-input>
          </div>
        </el-row>
      </div>
    </div>

    <el-row class="display-flex margin-top-15" v-if="sequenceFlow">
      <div class="text-right formLabel">比较：</div>
      <el-checkbox v-model="form.checkPoint" @change="setCondition('value')">值测点</el-checkbox>
      <el-checkbox v-model="form.newcheckPoint" @change="setCondition('valueName')">名称测点</el-checkbox>
    </el-row>

    <el-row class="display-flex margin-top-15" v-if="sequenceFlow && form.checkPoint || form.newcheckPoint">
      <div class="text-right formLabel">测点：</div>
      <div style="flex: 1">
        <el-select
          :disabled="!select"
          placeholder="请选择测点"
          @change="setCondition"
          size="mini"
          style="width: 100%;"
          v-model="form.pointId">
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in selectList">
          </el-option>
        </el-select>
      </div>
    </el-row>
    <el-row class="display-flex margin-top-15" v-if="sequenceFlow && form.checkPoint || form.newcheckPoint">
      <div class="text-right formLabel">条件：</div>
      <div style="flex: 1">
        <el-select v-model="form.pointCondition"
                   :disabled="!select"
                   style="width: calc(50% - 5px);margin-right: 5px"
                   @change="setCondition"
                   size="mini">
          <el-option v-for="item in conditionList"
                     :key="item.id" :label="item.label"
                     :value="item.label">
          </el-option>
        </el-select>
        <el-input v-model="form.pointConditionValue" size="mini"
                  :disabled="!select"
                  style="width: 50%"
                  @input="setCondition"
                  type="text"></el-input>
      </div>
    </el-row>

    <el-row class="display-flex margin-top-15" v-if="sequenceFlow">
      <div class="text-right formLabel">次数比较：</div>
      <el-checkbox v-model="form.checkCount" @change="setCondition">次数</el-checkbox>
    </el-row>
    <el-row class="display-flex margin-top-15" v-if="sequenceFlow && form.checkCount">
      <div class="text-right formLabel">条件：</div>
      <div style="flex: 1">
        <el-select v-model="form.countCondition"
                   :disabled="!select"
                   style="width: calc(50% - 5px);margin-right: 5px"
                   @change="setCondition"
                   size="mini">
          <el-option v-for="item in conditionList"
                     :key="item.id" :label="item.label"
                     :value="item.label">
          </el-option>
        </el-select>
        <el-input v-model="form.countConditionValue" size="mini"
                  :disabled="!select"
                  style="width: 50%"
                  @input="setCondition"
                  type="number"></el-input>
      </div>
    </el-row>
  </div>
</template>

<script>
import {getListByParentCode} from "@/network/extension";
import {stringIsNull} from "@/utils/tool";
import {getSpaceTreeData} from "@/network/space-info";
import {getDeviceList} from "@/network/device-info";
import {listByDeviceId} from "@/network/device-measuring-point";
import {dataCheck} from '@/constant/BpmData'
import _ from 'lodash';

export default {
  name: "BpmnPanel",
  props: {
    modeler: {
      type: Object,
      required: true
    },
    processData: {
      type: Object,
    }
  },
  computed: {
    taskListener() {
      if (!this.element) {
        return;
      }
      return this.element.type === "bpmn:UserTask";
    },
    sequenceFlow() {
      if (!this.element) {
        return;
      }
      return this.element.type === "bpmn:SequenceFlow";
    },
  },
  data() {
    return {
      moddle: null,
      modeling: null,
      businessObject: {},
      select: false, //是否选中节点
      form: {
        id: "",
        name: "",
        color: null,
        checkPoint: false,
        newcheckPoint: false,
        checkCount: false,
      },
      conditionList: [
        {id: 1, label: '>'},
        {id: 2, label: '<'},
        {id: 3, label: '=='},
        {id: 4, label: '!='},
        {id: 5, label: '>='},
        {id: 6, label: '<='},
      ],
      element: {},
      taskListenerService: [],
      dynamicObj: {},
      spaceTree: {},
      deviceList: [],
      pointList: [],
      selectList: [], //条件可选测点列表
      defaultProps: {
        label: 'title',
        value: 'id',
        children: 'children'
      },
      nodeNoData: [],
    };
  },
  mounted() {
    this.moddle = this.modeler._moddle;
    this.modeling = this.modeler.get("modeling");
    this.selectList = this.processData.description ? JSON.parse(this.processData.description) : [];
    this.getListByParentCode();
    this.getSpaceTreeData();
    this.handleModeler();
  },
  watch: {
    processData: {
      handler() {
        this.selectList = this.processData.description ? JSON.parse(this.processData.description) : [];
      },
      deep: true
    },
  },
  methods: {
    initData(init) {
      if (this.form.spaceIds) {
        this.getDeviceList(init)
      }
      this.addDynamicProperties()
    },
    //获取任务监听列表
    getListByParentCode() {
      getListByParentCode("task_listener_service").then(res => {
        if (res.code === 0) {
          this.taskListenerService = res.data
        }
      })
    },
    //获取级联空间
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          this.spaceTree = res.data
        }
      });
    },
    // 获取空间下设备列表
    getDeviceList(init) {
      if (this.form.spaceIds.length < 1) {
        this.deviceList = []
        return false;
      }
      //重新选择空间
      if (!init){
        this.form.deviceId = ''
        this.form.pointId = ''
      }
      this.updateModelingProperties()
      getDeviceList(this.form.spaceIds[this.form.spaceIds.length - 1]).then(res => {
        if (res.code === 0) {
          this.deviceList = res.data
          if (this.form.deviceId) {
            this.getPointListByDeviceId(init)
          }
        }
      })
    },
    // 获取设备的测点列表
    getPointListByDeviceId(init) {
      if (!this.form.deviceId) {
        return;
      }
      const device = this.deviceList.filter(item => item.id === this.form.deviceId)
      this.form.deviceName = device[0].name
      this.form.typeEngName = device[0].typeEngName
      //重新选择设备
      if (!init){
        this.form.pointId = ''
      }
      this.updateModelingProperties()
      listByDeviceId(this.form.deviceId).then(res => {
        if (res.code === 0) {
          this.pointList = res.data
        }
      });
    },
    selectPoint() {
      const point = this.pointList.filter(item => item.id === this.form.pointId)
      let obj = {
        id: this.form.deviceId + "_" + point[0].id,
        name: this.deviceList[0].spaceName+ "_" +this.form.deviceName + "_" + point[0].name,
        nodeId:this.form.id
      }
      // 如果新增的时候，测点值改变了，通过节点id判断，先把之前的删了，然后再加进去(一个任务只可能有一个测点)
      var filterList=[]
      this.selectList.forEach(item => {
          if(item.nodeId != this.form.id){
            filterList.push(item)
          }
      })
      this.selectList = _.unionBy(filterList, [obj], 'id')
      //任务监听添加监听节点
      this.setListener()
    },
    //任务监听添加动态属性
    addDynamicProperties() {
      this.dynamicObj = {}
      if (!stringIsNull(this.form.taskListener)) {
        const value = this.taskListenerService.filter(item => item.val1 === this.form.taskListener)
        if (value.length && !stringIsNull(value[0].val2)) {
          this.dynamicObj = JSON.parse(value[0].val2)
        }
      }
      //任务监听添加监听节点
      this.setListener()
    },
    //设置动态属性参数
    dynamic(value, item) {
      let obj = {};
      obj[item] = value
      //任务监听添加监听节点
      this.setListener()
    },
    //条件拼接和添加条件节点
    setCondition(data) {
      if (data=='value' &&  this.form.checkPoint) {
        console.log("value")
        this.form.newcheckPoint = false;
      }else if (data=='valueName' &&  this.form.newcheckPoint){
        console.log("valueName")
        this.form.checkPoint = false;
      }
      let pointCondition = ''
      let countCondition = ''
      if (this.form.checkPoint || this.form.newcheckPoint) {
        pointCondition = 'point_' + (this.form.pointId ? this.form.pointId : '')
          + (this.form.pointCondition ? this.form.pointCondition : '')
          + (this.form.pointConditionValue ? this.form.pointConditionValue : '')
      }
      if (this.form.newcheckPoint){
        if (this.form.pointCondition == '==' && this.form.pointConditionValue.indexOf("\"") != -1){
          pointCondition = 'point_' + (this.form.pointId ? this.form.pointId : '')+'_Name'
            + (this.form.pointCondition ? this.form.pointCondition : '')
            + (this.form.pointConditionValue ? this.form.pointConditionValue : '')
        }else{
          pointCondition = 'point_' + (this.form.pointId ? this.form.pointId : '')+'_Name'
            + (this.form.pointCondition ? this.form.pointCondition : '')
            + (this.form.pointConditionValue ?  "\""+this.form.pointConditionValue+ "\"" : '')
        }
      }
      if (this.form.checkCount) {
        countCondition = 'count' + (this.form.countCondition ? this.form.countCondition : '')
          + (this.form.countConditionValue ? this.form.countConditionValue : '')
      }
      this.updateModelingProperties();
      if (!stringIsNull(pointCondition + countCondition)) {
        //${point_190868020481101825_190868120905322496>0} //point_设备id_测点id
          const condition = '${' + pointCondition +
            ((!stringIsNull(pointCondition) && (!stringIsNull(countCondition))) ? '&&' : '')
            + countCondition + '}'
        //添加条件节点
        const newCondition = this.moddle.create('bpmn:FormalExpression', {
          body: condition
        });
        //<conditionExpression xsi:type="tFormalExpression"><![CDATA[${point_190868020481101825_190868120905322496>0}]]></conditionExpression>
        this.modeling.updateProperties(this.element, {conditionExpression: newCondition})
      }
    },
    //任务监听拼接和添加节点
    setListener() {
      let fields = []
      if (Object.keys(this.dynamicObj).length) {
        Object.keys(this.dynamicObj).forEach(key => {
          const value = this.form[key]
          const field = this.moddle.create("activiti:Field", {
            name: key,
            string: value
          })
          fields.push(field)
        })
      }
      /*<extensionElements>
        <activiti:taskListener event="create" delegateExpression="${getPointValueTask}">
          <activiti:field name="pointId">
            <activiti:string><![CDATA[190868120905322496]]></activiti:string>
          </activiti:field>
        </activiti:taskListener>
      </extensionElements>*/
      const delegateExpression = '${' + this.form.taskListener + '}'
      const listener = this.moddle.create("activiti:TaskListener", {
        delegateExpression: delegateExpression,
        event: "create",
        fields: fields
      })
      const extensionElements = this.moddle.create("bpmn:ExtensionElements", {
        values: [listener]
      })
      console.log(this.dynamicObj, extensionElements);
      this.modeling.updateProperties(this.element, {extensionElements: extensionElements})

      //更新documentation属性
      this.updateModelingProperties()
    },
    //节点监听
    handleModeler() {
      //监听形状删除
      this.modeler.on("shape.removed", e => {
        const {element} = e;
        if (!element) return;
        if (element.id === this.form.id) {
          this.form = {}
          this.nodeNoData = this.nodeNoData.filter(item => item.id !== element.id)
        }
      });
      //监听连线删除
      this.modeler.on("connection.removed", e => {
        const {element} = e;
        if (!element) return;
        if (element.id === this.form.id) {
          this.form = {}
          this.nodeNoData = this.nodeNoData.filter(item => item.id !== element.id)
        }
      });
      // 监听节点选择变化
      this.modeler.on("selection.changed", e => {
        const element = e.newSelection[0];
        this.element = element;
        //未选中节点
        if (!element) {
          this.select = false
          this.nodeDataCheck()
          return
        }
        this.businessObject = element.businessObject
        this.select = true
        this.form = {
          ...element.businessObject,
          ...element.businessObject.$attrs
        };
        if (this.form.documentation && this.form.documentation[0].text) {
          const json = JSON.parse(this.form.documentation[0].text)
          this.form = {...this.form, ...json}
        }
        this.initData(true)
      });

      //  监听节点属性变化
      this.modeler.on("element.changed", e => {
        const {element} = e;
        if (!element) return;
        //  新增节点需要更新回属性面板
        if (element.id === this.form.id) {
          this.form.name = element.businessObject.name;
          this.form = {...this.form};
        }
      });
    },
    //上个点击节点数据校验
    nodeDataCheck() {
      if (this.form.$type) {
        if (dataCheck[this.form.$type]) {
          let obj = dataCheck[this.form.$type]
          const id = this.form.id
          //如果为任务监听,加上动态属性判断
          if (this.form.$type === 'bpmn:UserTask' && Object.keys(this.dynamicObj).length) {
            obj = {...obj, ...this.dynamicObj}
          }
          //如果为条件
          if (this.form.$type === 'bpmn:SequenceFlow') {
            if (this.form.checkPoint || this.form.newcheckPoint) {
              const checkObj = dataCheck["checkPoint"]
              obj = {...obj, ...checkObj}
            }

            if (this.form.checkCount) {
              const checkObj = dataCheck["checkCount"]
              obj = {...obj, ...checkObj}
            }
          }
          //当return false时退出循环
          const value = Object.keys(obj).every(item => {
            if (stringIsNull(this.form[item])) {
              this.$message.error("ID为" + id + "的节点" + obj[item] + "不能为空!")
              return false;
            } else {
              return true;
            }
          })
          //添加数据不完整的节点id
          if (value) {
            this.nodeNoData = this.nodeNoData.filter(item => item.id !== id)
          } else {
            const node = this.nodeNoData.filter(item => item.id === id)
            if (node.length === 0) {
              this.nodeNoData.push(this.form)
            }
          }
        }
      }
    },
    // 属性面板名称，更新回流程节点
    nameChange(name) {
      this.modeling.updateLabel(this.element, name);
    },
    // 属性面板颜色，更新回流程节点
    colorChange(color) {
      this.modeling.setColor(this.element, {
        fill: null,
        stroke: color
      });
      this.modeling.updateProperties(this.element, {color: color});
    },
    // addProperty(properties, dynamic) {
    //   if (dynamic) {
    //     this.addDynamicProperties()
    //   }
    //   this.updateModelingProperties(
    //     Object.assign(properties, {
    //       // taskType: Object.keys(properties)[0]
    //     })
    //   );
    // },
    // 封装一个通用的更新documentation节点属性的方法
    updateModelingProperties() {
      // this.modeling.updateProperties(this.element, properties);
      //参数写入xml的documentation属性
      const obj = _.cloneDeep(this.form)
      this.$delete(obj, '$type')
      this.$delete(obj, 'documentation')
      this.$delete(obj, 'extensionElements')
      const documentation = this.moddle.create("bpmn:Documentation", {
        text: JSON.stringify(obj)
      })
      this.modeling.updateProperties(this.element, {documentation: [documentation]})
    }
  }
}
</script>

<style scoped>
.formLabel {
  flex-basis: 70px;
}
</style>
